/* bxgy-gallery.js — paged desktop gallery for product templates that opt in via
   <div data-bxgy-gallery data-per-page="8"> (rendered by the bxgy_picker block when "Desktop gallery page size" > 0).
   The desktop gallery on this theme is the 2-column grid `.product-images.desktop_image` (all images stacked).
   This shows only `perPage` images at a time with ‹ › arrows and "1–8 of 31"; mobile (Flickity hero) is untouched.
   Plays nicely with theme.js's "selected variant image to slot 1" swap: we re-read the DOM order on every render. */
(function () {
  'use strict';
  function init(cfg) {
    var grid = document.querySelector('.product-images.desktop_image');
    if (!grid || grid.__bxgyPaged) return; grid.__bxgyPaged = true;
    var per = parseInt(cfg.dataset.perPage, 10) || 8, page = 0;
    var nav = document.createElement('div'); nav.className = 'bxgy-gal';
    nav.innerHTML = '<button type="button" class="bxgy-gal__btn bxgy-gal__btn--prev" aria-label="Previous photos">&#8249;</button>'
      + '<span class="bxgy-gal__count" aria-live="polite"></span>'
      + '<button type="button" class="bxgy-gal__btn bxgy-gal__btn--next" aria-label="More photos">&#8250;</button>';
    grid.insertAdjacentElement('afterend', nav);
    var prev = nav.querySelector('.bxgy-gal__btn--prev'), next = nav.querySelector('.bxgy-gal__btn--next'), count = nav.querySelector('.bxgy-gal__count');
    function imgs() { return Array.prototype.slice.call(grid.children).filter(function (el) { return el.tagName === 'IMG'; }); }
    function render(scroll) {
      var list = imgs(), n = list.length, pages = Math.max(1, Math.ceil(n / per));
      page = Math.min(Math.max(page, 0), pages - 1);
      list.forEach(function (img, i) {
        var on = i >= page * per && i < (page + 1) * per;
        img.classList.toggle('bxgy-gal-hidden', !on);
        if (on && img.loading === 'lazy') img.loading = 'eager';
      });
      var a = page * per + 1, b = Math.min((page + 1) * per, n);
      count.textContent = n ? (a + '–' + b + ' of ' + n + ' photos') : '';
      prev.disabled = page === 0; next.disabled = page >= pages - 1;
      nav.hidden = n <= per;
      if (scroll) { var top = grid.getBoundingClientRect().top + window.pageYOffset - 110; window.scrollTo({ top: top, behavior: 'smooth' }); }
    }
    prev.addEventListener('click', function () { page--; render(true); });
    next.addEventListener('click', function () { page++; render(true); });
    // theme.js swaps the selected variant's image into slot 1 (~250ms after a variant change); our picker fires bxgy:pick
    var mo = new MutationObserver(function () { render(false); });
    mo.observe(grid, { childList: true });
    document.addEventListener('bxgy:pick', function () { page = 0; render(false); });
    render(false);
  }
  /* Phones/tablets use the Flickity hero + thumbnail strip. Every non-featured slide is lazy-loaded, so tapping a
     thumbnail waits on a fresh download (the "lag"). After load, warm the slides in the background a few at a time,
     and on a thumbnail tap/touch force that slide eager immediately. Skips Save-Data connections. */
  function warmMobileSlides() {
    if (window.innerWidth >= 990) return;
    if (navigator.connection && navigator.connection.saveData) return;
    var slides = Array.prototype.slice.call(document.querySelectorAll('.product-main-slide img[loading="lazy"]'));
    if (!slides.length) return;
    // The theme keeps `.lazyload` images at opacity 0 until its <image-element> swaps the class to `.lazyloaded`,
    // and it only does that for img[loading="lazy"] via an IntersectionObserver. Once we flip an image to eager we
    // must do the class swap ourselves (when the bytes are in), or the slide stays invisible.
    function reveal(img) {
      var show = function () { img.classList.remove('lazyload'); img.classList.add('lazyloaded'); };
      if (img.complete && img.naturalWidth > 0) show(); else { img.addEventListener('load', show, { once: true }); img.addEventListener('error', show, { once: true }); }
    }
    function warm(img) { if (img.loading !== 'eager') img.loading = 'eager'; reveal(img); if ('decode' in img) img.decode().catch(function () {}); }
    var i = 0;
    function next() {
      for (var n = 0; n < 2 && i < slides.length; n++, i++) warm(slides[i]);
      if (i < slides.length) setTimeout(next, 250);
    }
    var start = function () { setTimeout(next, 800); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
    var thumbs = document.querySelector('[data-product-thumbs]');
    if (thumbs) {
      var force = function (e) {
        var a = e.target.closest('[data-product-thumb]'); if (!a) return;
        var idx = parseInt(a.dataset.index, 10); var all = document.querySelectorAll('.product-main-slide img');
        if (all[idx]) { all[idx].fetchPriority = 'high'; warm(all[idx]); }
      };
      thumbs.addEventListener('touchstart', force, { passive: true });
      thumbs.addEventListener('mousedown', force);
    }
  }

  function boot() { document.querySelectorAll('[data-bxgy-gallery]').forEach(init); warmMobileSlides(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
